export const PAYMENT_MODE = [
    {
        name: 'Debit Card',
        value: 'DC',
    },
    {
        name: 'Credit Card',
        value: 'CC',
    },
    {
        name: 'Net Banking',
        value: 'NB',
    },
    {
        name: 'UPI',
        value: 'UPI',
    },
    {
        name: 'Wallet',
        value: 'WALLET',
    },
    {
        name: 'Verification',
        value: 'VERIFICATION',
    },
    {
        name: 'EMI',
        value: 'EMI_CC',
    },
];
